export default function Hero() {
  return (
    <section
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{ background: '#0f0f0f' }}
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/601c936e85458a93e8e14ae6909a8d86.jpg"
          alt="Luxury interior painting by Hometown Painters Elk Grove Village Illinois"
          title="Premier painting company Elk Grove Village IL"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal-900/70 via-charcoal-900/50 to-charcoal-900/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 flex flex-col items-center text-center">
        {/* Eyebrow */}
        <div className="flex items-center gap-3 mb-8 animate-fade-in">
          <span className="w-12 h-px bg-gold" />
          <span className="font-sans text-gold text-xs tracking-[0.3em] uppercase">Premier Painting Company · Elk Grove Village, IL</span>
          <span className="w-12 h-px bg-gold" />
        </div>

        {/* Headline */}
        <h1 className="font-serif text-warm-white text-5xl md:text-7xl leading-tight mb-6 animate-fade-up max-w-4xl">
          Precision Painting.
          <br />
          <em className="text-gold not-italic">Elevated Spaces.</em>
        </h1>

        {/* Subheadline */}
        <p className="font-sans text-warm-muted text-base md:text-lg leading-relaxed mb-10 max-w-2xl animate-fade-up">
          Interior and exterior painting crafted with clean lines, premium materials, and
          detail-driven execution across Elk Grove Village homes and commercial properties.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4 animate-fade-up">
          <a
            href="#quote"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('quote')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-gold text-charcoal-900 font-sans font-medium text-sm px-8 py-4 rounded-full hover:bg-gold-light transition-all duration-300 hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            Get a Free Quote
          </a>
          <a
            href="tel:8478701600"
            className="flex items-center gap-2 border border-warm-white/40 text-warm-white font-sans text-sm px-8 py-4 rounded-full hover:border-gold hover:text-gold transition-all duration-300 hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line" style={{ fontSize: '14px' }} />
            </div>
            (847) 870-1600
          </a>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="font-sans text-warm-dim text-xs tracking-widest uppercase">Scroll</span>
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-down-line text-gold" style={{ fontSize: '16px' }} />
          </div>
        </div>
      </div>
    </section>
  );
}
